import React, { useState } from 'react';
import MenuGenerator from './pages/MenuGenerator';
import './App.css';

export default function App() {
  const [venue, setVenue] = useState({
    name: '',
    logo_base64: '',
    brand_colour: '#c9a86a',
    meal_types: ['Lunch Features', 'Dinner Features', 'Desserts', 'Weekend Features', 'Brunch Features', 'Specials']
  });
  const [headerControls, setHeaderControls] = useState(null);

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="wordmark" style={{ cursor: 'pointer' }}>
          <strong>Menu</strong>Tide
        </div>

        {headerControls?.center && (
          <div className="app-header-center">
            {headerControls.center}
          </div>
        )}

        {headerControls?.right && (
          <div className="app-header-right">
            {headerControls.right}
          </div>
        )}
      </header>

      <main className="app-main">
        <MenuGenerator venue={venue} onVenueChange={setVenue} setHeaderControls={setHeaderControls} />
      </main>
    </div>
  );
}
